<div class="h-full w-full flex flex-col items-start justify-start overflow-y-auto scrollbar-transparent space-y-4">


    @if (noSparkCampaign() === true) {
    <!-- Advertising Objective -->
    <bttv2-advertising-objective-parent class="w-full"></bttv2-advertising-objective-parent>
    <!-- Advertising Objective - END -->

    <!-- Settings -->
    <bttv2-advertising-settings class="w-full"></bttv2-advertising-settings>
    <!-- Settings - END -->

    <!-- Select Advertiser -->
    <bttv2-advertising-advertiser-id class="w-full"></bttv2-advertising-advertiser-id>
    <!-- Select Advertiser - END -->

    <!-- Submit Button -->
    <div class="w-full flex flex-row items-center justify-end gap-x-2">
        <button type="button" (click)="createSparkCampaign()"
            class="inline-flex items-center gap-x-1.5 rounded-md bg-primary px-2.5 py-1.5 text-sm font-semibold text-white shadow-xs hover:bg-primary/90 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary dark:bg-primary dark:shadow-none dark:hover:bg-primary/90 dark:focus-visible:outline-primary">
            Add Campaign
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="-mr-0.5 size-5">
                <path d="M5 12h14" />
                <path d="M12 5v14" />
            </svg>
        </button>
    </div>
    <!-- Submit Button - END-->

    } @else if (noSparkCampaign() === false && createSparkCampaignService.currentSparkCampaign() !== undefined) {
    <div class="h-full w-full flex flex-col items-stretch justify-start overflow-hidden flex-1 min-h-0 gap-y-4">
        <!-- We Have a Campaign -->

        <!-- Campaign + optional ad group summary row (full width vs 50/50) -->
        <div class="flex w-full shrink-0 gap-3"
            [class]="createSparkCampaignService.currentSparkAdGroup() !== undefined ? 'flex-row' : 'flex-col'">

            <!-- Campaign Summary Card -->
            <div class="flex flex-row items-center justify-between gap-x-3 rounded-xl border border-gray-200 bg-white p-3 shadow-sm dark:border-white/10 dark:bg-white/5"
                [class]="createSparkCampaignService.currentSparkAdGroup() !== undefined ? 'min-w-0 flex-1 basis-0' : 'w-full'">

                <div class="flex flex-row gap-x-4">

                    <!-- TikTok Icon -->
                    <div class="shrink-0 flex size-10 items-center justify-center rounded-lg bg-black dark:bg-white/10">
                        <svg class="size-5 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                            fill="currentColor" aria-hidden="true">
                            <path
                                d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.95a8.17 8.17 0 0 0 4.77 1.52V7.01a4.85 4.85 0 0 1-1-.32z" />
                        </svg>
                    </div>

                    <!-- Campaign Info -->
                    <div class="min-w-0 flex-1">

                        <!-- Name + Status -->
                        <div class="flex flex-wrap items-center gap-x-2 gap-y-1">
                            <p class="truncate text-sm font-semibold text-gray-900 dark:text-white">
                                {{ createSparkCampaignService.currentSparkCampaign()?.campaignName }}
                            </p>
                        </div>

                        <!-- Meta Row -->
                        <dl class="mt-1 flex flex-wrap items-center gap-x-4 gap-y-0.5">

                            <!-- Budget -->
                            <div class="flex items-center gap-x-1">
                                <svg class="size-3.5 shrink-0 text-gray-400 dark:text-gray-500"
                                    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                                    stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" aria-hidden="true">
                                    <line x1="12" y1="2" x2="12" y2="22" />
                                    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
                                </svg>
                                <dd class="text-xs text-gray-500 dark:text-gray-400">
                                    {{ formatSparkBudget(createSparkCampaignService.currentSparkCampaign()?.budget) }}
                                    <span class="text-gray-400 dark:text-gray-500">({{
                                        sparkBudgetModeLabel(createSparkCampaignService.currentSparkCampaign()?.budgetMode)
                                        }})</span>
                                </dd>
                            </div>

                            <!-- Created -->
                            <div class="flex items-center gap-x-1">
                                <svg class="size-3.5 shrink-0 text-gray-400 dark:text-gray-500"
                                    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                                    stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" aria-hidden="true">
                                    <rect width="18" height="18" x="3" y="4" rx="2" ry="2" />
                                    <line x1="16" x2="16" y1="2" y2="6" />
                                    <line x1="8" x2="8" y1="2" y2="6" />
                                    <line x1="3" x2="21" y1="10" y2="10" />
                                </svg>
                                <dd class="text-xs text-gray-500 dark:text-gray-400">{{
                                    formatSparkDate(createSparkCampaignService.currentSparkCampaign()?.createTime) }}
                                </dd>
                            </div>

                            <!-- Objective -->
                            <div class="flex items-center gap-x-1">
                                <svg class="size-3.5 shrink-0 text-gray-400 dark:text-gray-500"
                                    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                                    stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" aria-hidden="true">
                                    <circle cx="12" cy="12" r="10" />
                                    <circle cx="12" cy="12" r="6" />
                                    <circle cx="12" cy="12" r="2" />
                                </svg>
                                <dd class="text-xs text-gray-500 dark:text-gray-400">{{
                                    formatObjectiveType(createSparkCampaignService.currentSparkCampaign()?.objectiveType)
                                    }}
                                </dd>
                            </div>

                        </dl>
                    </div>
                </div>

                <span
                    [class]="'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ' + sparkOperationStatusClass(createSparkCampaignService.currentSparkCampaign()?.operationStatus)">
                    {{ sparkOperationStatusLabel(createSparkCampaignService.currentSparkCampaign()?.operationStatus) }}
                </span>

            </div>
            <!-- Campaign Summary Card - END -->

            <!-- Ad Group Summary Card (selected row) -->
            @if (createSparkCampaignService.currentSparkAdGroup(); as group) {
            <div
                class="min-w-0 flex-1 basis-0 flex flex-row items-center justify-between gap-x-3 rounded-xl border border-gray-200 bg-white p-3 shadow-sm dark:border-white/10 dark:bg-white/5">

                <div class="flex flex-row gap-x-4">

                    <!-- TikTok Icon -->
                    <div class="shrink-0 flex size-10 items-center justify-center rounded-lg bg-black dark:bg-white/10">
                        <svg class="size-5 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                            fill="currentColor" aria-hidden="true">
                            <path
                                d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.95a8.17 8.17 0 0 0 4.77 1.52V7.01a4.85 4.85 0 0 1-1-.32z" />
                        </svg>
                    </div>

                    <!-- Ad group info -->
                    <div class="min-w-0 flex-1">

                        <div class="flex flex-wrap items-center gap-x-2 gap-y-1">
                            <p class="truncate text-sm font-semibold text-gray-900 dark:text-white"
                                [attr.title]="group.adgroupName ?? ''">
                                {{ group.adgroupName ?? '—' }}
                            </p>
                        </div>

                        <dl class="mt-1 flex flex-wrap items-center gap-x-4 gap-y-0.5">

                            <!-- Budget -->
                            <div class="flex items-center gap-x-1">
                                <svg class="size-3.5 shrink-0 text-gray-400 dark:text-gray-500"
                                    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                                    stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" aria-hidden="true">
                                    <line x1="12" y1="2" x2="12" y2="22" />
                                    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
                                </svg>
                                <dd class="text-xs text-gray-500 dark:text-gray-400">
                                    {{ formatSparkBudget(group.budget ?? undefined) }}
                                    <span class="text-gray-400 dark:text-gray-500">({{
                                        sparkBudgetModeLabel(group.budgetMode ?? undefined)
                                        }})</span>
                                </dd>
                            </div>

                            <!-- Created -->
                            <div class="flex items-center gap-x-1">
                                <svg class="size-3.5 shrink-0 text-gray-400 dark:text-gray-500"
                                    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                                    stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" aria-hidden="true">
                                    <rect width="18" height="18" x="3" y="4" rx="2" ry="2" />
                                    <line x1="16" x2="16" y1="2" y2="6" />
                                    <line x1="8" x2="8" y1="2" y2="6" />
                                    <line x1="3" x2="21" y1="10" y2="10" />
                                </svg>
                                <dd class="text-xs text-gray-500 dark:text-gray-400">{{
                                    formatSparkDate(group.createTime ?? undefined) }}</dd>
                            </div>

                            <!-- Optimization goal -->
                            <div class="flex items-center gap-x-1">
                                <svg class="size-3.5 shrink-0 text-gray-400 dark:text-gray-500"
                                    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                                    stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" aria-hidden="true">
                                    <line x1="4" x2="4" y1="21" y2="14" />
                                    <line x1="4" x2="4" y1="10" y2="3" />
                                    <line x1="12" x2="12" y1="21" y2="12" />
                                    <line x1="12" x2="12" y1="8" y2="3" />
                                    <line x1="20" x2="20" y1="21" y2="16" />
                                    <line x1="20" x2="20" y1="12" y2="3" />
                                    <line x1="1" x2="7" y1="14" y2="14" />
                                    <line x1="9" x2="15" y1="8" y2="8" />
                                    <line x1="17" x2="23" y1="16" y2="16" />
                                </svg>
                                <dd class="text-xs text-gray-500 dark:text-gray-400">{{
                                    formatAdGroupApiValue(group.optimizationGoal) }}</dd>
                            </div>

                        </dl>
                    </div>
                </div>

                <div class="shrink-0 flex flex-col items-end gap-2 sm:flex-row sm:items-center">
                    <button type="button" (click)="clearSelectedSparkAdGroup()"
                        class="inline-flex items-center justify-center rounded-md border border-gray-300 bg-white px-2 py-1 text-xs font-medium text-gray-700 shadow-xs hover:bg-gray-50 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-400 dark:border-white/15 dark:bg-white/5 dark:text-gray-200 dark:hover:bg-white/10 dark:focus-visible:outline-gray-500">
                        All ad groups
                    </button>
                    <span
                        [class]="'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ' + sparkOperationStatusClass(group.operationStatus ?? undefined)">
                        {{ sparkOperationStatusLabel(group.operationStatus ?? undefined) }}
                    </span>
                </div>

            </div>
            }
        </div>
        <!-- Campaign + ad group summary row - END -->

        <!-- Ads table placeholder (real table TBD) -->
        @if (createSparkCampaignService.currentSparkAdGroup()) {

        <div class="flex-1 flex flex-col w-full p-2 items-center justify-center">

            <div class="text-center">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true"
                    class="mx-auto size-12 text-gray-400 dark:text-gray-500">
                    <path d="M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
                        stroke-width="2" vector-effect="non-scaling-stroke" stroke-linecap="round"
                        stroke-linejoin="round" />
                </svg>
                <h3 class="mt-2 text-sm font-semibold text-gray-900 dark:text-white">No Ads in this Ad Group</h3>
                <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">Create a new Ad to boost a post.</p>
                <div class="mt-6">
                    <button (click)="goToCreateAd()" type="button"
                        class="inline-flex items-center rounded-md bg-primary px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-primary/90 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary dark:bg-primary dark:shadow-none dark:hover:bg-primary/90 dark:focus-visible:outline-primary">
                        <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                            class="mr-1.5 -ml-0.5 size-5">
                            <path
                                d="M10.75 4.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z" />
                        </svg>
                        Create Spark Ad
                    </button>
                </div>
            </div>
        </div>

        <!-- <div class="flex-1 min-h-0 w-full border-2 border-blue-500">
            <button (click)="goToCreateAd()" type="button"
                class="inline-flex items-center gap-x-1.5 rounded-md bg-primary px-2.5 py-1.5 text-sm font-semibold text-white shadow-xs hover:bg-primary/90 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary dark:bg-primary dark:shadow-none dark:hover:bg-primary/90 dark:focus-visible:outline-primary">
                Create Ad
                <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true" class="-mr-0.5 size-5">
                    <path
                        d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z"
                        clip-rule="evenodd" fill-rule="evenodd" />
                </svg>
            </button>
        </div> -->
        }
        <!-- Ads placeholder - END -->

        <!-- Ad Groups Table (no row selected) -->
        @else if (createSparkCampaignService.currentSparkCampaign() &&
        createSparkCampaignService.currentSparkCampaign()!.tiktokSparkAdGroups.length > 0) {
        <bttv2-spark-ad-groups-table class="flex-1 min-h-0 w-full"
            [adGroups]="createSparkCampaignService.currentSparkCampaign()!.tiktokSparkAdGroups" />
        }
        <!-- Ad Groups Table - END -->

        @else {
        <div class="flex-1 flex flex-col w-full p-2 items-center justify-center">

            <div class="text-center">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true"
                    class="mx-auto size-12 text-gray-400 dark:text-gray-500">
                    <path d="M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
                        stroke-width="2" vector-effect="non-scaling-stroke" stroke-linecap="round"
                        stroke-linejoin="round" />
                </svg>
                <h3 class="mt-2 text-sm font-semibold text-gray-900 dark:text-white">No Ad Groups</h3>
                <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">Get started by creating a new Ad Group.</p>
                <div class="mt-6">
                    <button (click)="goToAdGroupCreate()" type="button"
                        class="inline-flex items-center rounded-md bg-primary px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-primary/90 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary dark:bg-primary dark:shadow-none dark:hover:bg-primary/90 dark:focus-visible:outline-primary">
                        <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                            class="mr-1.5 -ml-0.5 size-5">
                            <path
                                d="M10.75 4.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z" />
                        </svg>
                        New Ad Group
                    </button>
                </div>
            </div>
        </div>
        }

        <!-- We Have a Campaign - END -->
    </div>
    } @else {
    <div class="flex flex-col items-center justify-center">
        <p class="text-sm text-gray-500 dark:text-gray-400">Loading...</p>
    </div>
    }

</div>

@if (creatingSparkCampaign()) {
<atom-loading-overlay></atom-loading-overlay>
}